class ChangeAdminPasswordController {
    // @ngInject
    constructor(targetUser, group) {
        this.targetUser = targetUser;
        this.group = group;
    }
}

export default ChangeAdminPasswordController;
